/**
 * @file Определения функций сортировки для каталога.
 * Экспортирует объект с именованными компараторами, применяемыми к отфильтрованным элементам каталога.
 */

/**
 * Сортирует элементы по числовому свойству в убывающем порядке.
 * При равных значениях сохраняет исходный порядок через `originalIndex`.
 * Элементы с null-значением помещаются в конец.
 * @param {object} a
 * @param {object} b
 * @param {string} property - Имя числового свойства для сравнения.
 * @returns {number}
 */
function compareDescending(a, b, property) {
  const aValue = a[property]
  const bValue = b[property]

  if (aValue === bValue) return a.originalIndex - b.originalIndex
  if (aValue === null) return 1
  if (bValue === null) return -1

  return bValue - aValue
}

/**
 * Именованные компараторы сортировки каталога.
 * - `default` — исходный порядок элементов.
 * - `high-rating` — по убыванию рейтинга.
 * - `new` — по убыванию даты создания.
 * @type {Object.<string, function(object, object): number>}
 */
const sortDefinitions = {
  'default': function (a, b) {
    return a.originalIndex - b.originalIndex
  },

  'high-rating': function (a, b) {
    return compareDescending(a, b, 'rating')
  },

  'new': function (a, b) {
    return compareDescending(a, b, 'createdAt')
  }
}

export default sortDefinitions
